<template>
  <section :class="canEdit?'c_p':''" style="padding: 4px 4px 4px 0px;min-width: 20px;" v-if="!editFlag" @dblclick="canEdit?showInput():''">{{$commonJs.numFixed(showValue)}}</section>
  <section v-else>
    <input @input="replaceVal" @keypress.enter="save()" class="mktEditTool" :id="randomId" type="text" v-model="changeValue"/>
    <i class="icon iconfont icon-guanbi" style="font-weight: normal" @click="cancel()"></i>
    <i class="icon iconfont icon-wancheng" style="font-weight: normal" @click="save()"></i>
  </section>
</template>
<script>
export default {
  name: 'mktEditTool',
  model: {
    prop: 'value',
    event: 'changeValue'
  },
  props: [
    'value',
    'canEdit'
  ],
  data () {
    return {
      changeValue: this.value,
      showValue: this.value,
      editFlag: false,
      randomId: 'selectId' + new Date().getTime() + Math.random() * 1000
    }
  },
  methods: {
    replaceVal () {
      if (this.changeValue.toString() === '-' || this.changeValue.toString() === '--') {
        this.changeValue = '-'
      }
      if (this.changeValue.toString() !== '0' && this.changeValue.toString() !== '-') {
        this.changeValue = this.changeValue.indexOf('-') === 0 ? (this.changeValue.replace(/\D|^[0]+/g, '') * -1) : this.changeValue.replace(/\D|^[0]+/g, '')
      } else {
        this.changeValue = this.changeValue
      }
    },
    showInput () {
      if (document.querySelectorAll('.mktEditTool').length > 0) {
        this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.CanNotEditOther'),
          stayTime: 3
        })
      } else {
        this.editFlag = true
        this.changeValue = this.value
        setTimeout(() => {
          document.getElementById(this.randomId).focus()
        }, 100)
      }
    },
    save () {
      if (this.changeValue === '') {
        this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.CellCanNotEmpty'),
          stayTime: 5
        })
        document.getElementById(this.randomId).focus()
        return false
      }
      this.showValue = this.changeValue
      this.$emit('changeValue', this.changeValue)
      this.editFlag = false
    },
    cancel () {
      this.editFlag = false
    }
  }
}
</script>
<style scoped>
  input{
    width: 100%;
    position: relative;
    font-size: 12px;
    border: 1px solid #C73343;
    border-radius: 4px;
    padding: 4px;
    margin-top: -4px;
    margin-left: -4px;
    outline: none;
  }
  section{
    position: relative;
    display: inline-block;
  }
  .iconfont{
    position: absolute;
    font-size: 13px;
    bottom: -8px;
    background-color: white;
  }
  .icon-wancheng{
    color: #6B853E;
    right: -7px;
  }
  .icon-guanbi{
    color: #B62A40;
    left: -6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/myComponents/mktTd.vue